import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

const homeUrl =
  (environment as typeof environment & { HOME_URL?: string }).HOME_URL ||
  environment.URL;
const homeDestination = new URL(homeUrl, window.location.origin);
const isHomeDestination =
  window.location.origin === homeDestination.origin &&
  window.location.pathname.replace(/\/$/, '') ===
    homeDestination.pathname.replace(/\/$/, '');

if (window.location.pathname === '/' && !isHomeDestination) {
  window.location.replace(homeDestination.href);
} else {
  bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err),
  );
}
